import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`;
const Title = styled.p`
  font-size: 20px;
  font-weight: bold;
  color: #101828;
`;
const ArrowLink = styled.a`
  font-size: 14px;
  color: #475467;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  &::after {
    content: "";
    width: 8px;
    height: 8px;
    border-right: 2px solid #475467;
    border-top: 2px solid #475467;
    transform: rotate(45deg);
    display: inline-block;
  }
  &:hover {
    color: #1d2939;
  }
  &:hover::after {
    border-color: #1d2939;
  }
`;

function HeaderLink({ title, link, onClick }) {
  const handleClick = (e) => {
    e.preventDefault();
    if (onClick) {
      onClick(e);
    } else if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Container>
      <Title>{title}</Title>
      <ArrowLink href={link || "#"} onClick={handleClick}>
        ดูทั้งหมด
      </ArrowLink>
    </Container>
  );
}

export default HeaderLink;
